import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-dusk"]
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "w-28 h-28 p-2 rounded border flex items-center justify-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = {
  class: "text-lg font-semibold",
  "data-dusk": "product-title"
}
const _hoisted_7 = { class: "border-t border-gray-200 mt-6" }
const _hoisted_8 = { class: "grid grid-cols-5 gap-6 mt-6" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { class: "mt-8" }
const _hoisted_15 = {
  "data-dusk": "power-selection",
  class: "mt-4"
}
const _hoisted_16 = { class: "mt-4 flex justify-end" }

import { computed, ref } from 'vue';
import { BaseButton } from '@/lib/components/Button';
import { BaseSelectDropdown } from '@/lib/components/Select';
import { BaseIcon } from '@/lib/components/Icon';
import { PowerSelection } from '@/lib/components/PowerSelection';
import { useI18n } from 'vue-i18n';
import { useProductCard } from '@/composables/use-product-card';
import { LensProperty, ProductImage, Variant } from '@/models/webshop.model';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCardMultiPower',
  props: {
    mlsId: {},
    productCategory: {},
    productCategorySlug: {},
    title: {},
    image: {},
    lensProperties: {},
    variants: {},
    lensCode: {},
    dataDusk: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const route = useRoute();
const currentOrganisationId = computed(() => route.params.organisationId as string);
const powerSelectionRef = ref<InstanceType<typeof PowerSelection> | null>(null);

const {
  radius,
  diameter,
  cylinder,
  axis,
  pack,
  showPowerSelection,
  selectedPowerQuantities,
  radiusOptions,
  diameterOptions,
  cylinderOptions,
  axisOptions,
  packOptions,
  powerOptions,
  isAddToCartDisabled,
  handleAddToCart
} = useProductCard({
  mlsId: props.mlsId,
  productName: props.title,
  productCategory: props.productCategory,
  productCategorySlug: props.productCategorySlug,
  lensProperties: props.lensProperties,
  variants: props.variants,
  image: props.image,
  lensCode: props.lensCode,
  powerSelectionMode: 'multi',
  powerSelectionRef,
  organisationId: currentOrganisationId
});

const cardDusk = computed(() => props.dataDusk || 'product-card-id');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "border rounded-lg p-10 shadow-sm bg-white w-full",
    "data-dusk": cardDusk.value
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.image?.url || 'https://placehold.co/350x180/EEEEEE/AAAAAA?text=No+image',
          alt: _ctx.title,
          class: "max-w-full max-h-full object-contain"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_unref(radiusOptions) && _unref(radiusOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(radius),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(radius) ? (radius).value = $event : null)),
                label: _unref(t)('platform.webshop.radius'),
                placeholder: _unref(t)('platform.webshop.placeHolders.radius'),
                options: _unref(radiusOptions),
                "data-dusk": "radius-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(diameterOptions) && _unref(diameterOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(diameter),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(diameter) ? (diameter).value = $event : null)),
                label: _unref(t)('platform.webshop.diameter'),
                placeholder: _unref(t)('platform.webshop.placeHolders.diameter'),
                options: _unref(diameterOptions),
                "data-dusk": "diameter-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(cylinderOptions) && _unref(cylinderOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(cylinder),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(cylinder) ? (cylinder).value = $event : null)),
                label: _unref(t)('platform.webshop.cylinder'),
                placeholder: _unref(t)('platform.webshop.placeHolders.cylinder'),
                options: _unref(cylinderOptions),
                "data-dusk": "cylinder-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(axisOptions) && _unref(axisOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(axis),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(axis) ? (axis).value = $event : null)),
                label: _unref(t)('platform.webshop.axis'),
                placeholder: _unref(t)('platform.webshop.placeHolders.axis'),
                options: _unref(axisOptions),
                "data-dusk": "axis-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(packOptions) && _unref(packOptions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_unref(BaseSelectDropdown), {
                modelValue: _unref(pack),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pack) ? (pack).value = $event : null)),
                label: _unref(t)('platform.webshop.pack'),
                placeholder: _unref(t)('platform.webshop.placeHolders.pack'),
                options: _unref(packOptions),
                "data-dusk": "pack-select"
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", {
          class: "text-sm font-medium cursor-pointer select-none text-center flex items-center justify-center gap-3",
          "data-dusk": "show-power-selection",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showPowerSelection.value = !_unref(showPowerSelection)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(showPowerSelection) ? _unref(t)('platform.webshop.hide-power') : _unref(t)('platform.webshop.show-power')), 1),
          _createVNode(_unref(BaseIcon), {
            name: _unref(showPowerSelection) ? 'product-arrow-up' : 'product-arrow-down',
            class: _normalizeClass(["text-sm stroke-1.5", 'text-gray-500'])
          }, null, 8, ["name"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(PowerSelection), {
            ref_key: "powerSelectionRef",
            ref: powerSelectionRef,
            modelValue: _unref(showPowerSelection),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showPowerSelection) ? (showPowerSelection).value = $event : null)),
            "power-options": _unref(powerOptions),
            "onUpdate:powerQuantities": _cache[7] || (_cache[7] = ($event: any) => (selectedPowerQuantities.value = $event))
          }, null, 8, ["modelValue", "power-options"])
        ], 512), [
          [_vShow, _unref(showPowerSelection)]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_unref(BaseButton), {
          size: "large",
          "left-icon": 'add',
          class: "px-6 py-3 bg-blue-600 rounded-md hover:bg-blue-700 flex items-center gap-2",
          disabled: _unref(isAddToCartDisabled),
          "data-dusk": "add-to-cart-button",
          onClick: _unref(handleAddToCart)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('platform.webshop.addToCart')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})